import DsBadge from "components/DsBadge";
import { IDelegation, IVehicleElement } from "dataModels/contract";
import moment from "moment";
import { ReactNode } from "react";
import { BadgeStatus, CalendarSlotStatus, DATE_FORMAT, DsLayout, EntityType, RoutePath } from "shared/constants";
import { getBadgeStatus } from "./driverVehicleBadgeStatus";
import { Button, NotificationBadge } from "@ds/ds-snam/react";
import TableRighArrow from "components/TableRightArrow";
import { v4 as uuid } from "uuid";
import { NavigateFunction } from "react-router";
import { TFunction } from "i18next";
import { IBookingElement } from "views/b2bView/bookingList";
import { getBookingBadgeStatus } from "views/b2bView/shared/bookingBadgeStatus";
import DriverVehicleListTableLegend from "../components/driverVehicleListTableLegend";
import { useSelector } from "react-redux";
import { RootState } from "state/appStore";
import { CalendarDayServiceType } from "dataModels/b2b";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";

export const getVehicleRows = (tableType: BadgeStatus,vehicleList:any,navigate:NavigateFunction,t:TFunction<[string, string, string], undefined>,type:EntityType) => {
    if (!vehicleList)
        return [];
    const list: IVehicleElement[] = tableType === BadgeStatus.TO_CREDIT ? vehicleList[BadgeStatus.TO_CREDIT] : vehicleList[BadgeStatus.CREDITED];
    
    let rows: ReactNode = list.map((vehicle: IVehicleElement) => {

        return (
            <tr key={uuid()}>
                <td>
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <DsBadge notificationStatus={getBadgeStatus(vehicle.status, tableType)} />
                        {t(`vehicle.vehicleList.vehicleType.${vehicle.type}`)}
                    </span>
                </td>
                <td>{vehicle.licencePlate}</td>
                <td>{parseDateForDS(moment.unix(vehicle.date).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}</td>
                {type===EntityType.VEHICLE && <td>
                    {/*tableType === BadgeStatus.TO_CREDIT ?
                        <Button
                            buttonType="button"
                            buttonUIVariant="secondary"
                            buttonSize="small"
                            buttonLabel={t('general.buttons.verifyElement', { ns: 'app', what: t('vehicle.vehicleList.addButton') })}//"Verifica componente
                            //buttonIcon="icon-add"
                            isDisabled={false}
                            buttonAriaLabel="verify component"
                            onClickEvent={() => {
                                navigate(vehicle.vehicleId);
                            }}
                        ></Button> :
                        <TableRighArrow onClick={() => {
                            navigate(vehicle.vehicleId);
                        }} />
                    */}
                    <TableRighArrow onClick={() => {
                            navigate(vehicle.vehicleId);
                        }} />
                </td>}
            </tr>
        );

    });

    return rows;

}

export const parseService = (service:number) => {
    switch (service) {
        case (CalendarDayServiceType.TRUCK_LOADING): //0
            return 'Truck loading'
        case (CalendarDayServiceType.COOL_DOWN_TL): //1
            return 'Cool down'
        case (CalendarDayServiceType.GAS_UP_COOL_DOWN_TL): //2
            return 'Gas up + Cool down'
        case (CalendarDayServiceType.SEMI_TRAILER_APPROVAL_TL): //3
            return 'Semi trailer approval'
        case (CalendarDayServiceType.DRIVER_APPROVAL_TL): //4
            return 'Driver approval'
        case (CalendarDayServiceType.SEMI_TRAILER_DRIVER_APPROVAL_TL): //5
            return 'Semi trailer approval + Driver approval'
        case (CalendarDayServiceType.ISO_CONTAINER_APPROVAL_TL): //6
            return 'Iso container approval'
        case (CalendarDayServiceType.ISO_CONTAINER_DRIVER_APPROVAL_TL): //7
            return 'Iso container approval + driver approval'
        default:
            return '';
    }
}

export const getTableBookingRows = (bookings:any,navigate:NavigateFunction,type:EntityType) => {
    let tableRows = bookings.map((booking: IBookingElement) => {
        return <tr key={uuid()}>
            <td>
                <span  className="ff-lato" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {(booking.status!==CalendarSlotStatus.CANCELLED && booking.status!==CalendarSlotStatus.SLOT_DELETED) ?
                            <>
                                 <DsBadge notificationStatus={getBookingBadgeStatus(booking.status)} />
                            </>
                        :
                            <>
                                {booking.status===CalendarSlotStatus.CANCELLED ?
                                    <>
                                        <NotificationBadge
                                            notificationStatus={"custom"}
                                            badgeVariant={"default"}
                                            badgeAriaLabel={"Badge aria label"}
                                            isSmall={false}
                                            backgroundColor={'#9A0557'}
                                        />
                                    </>
                                :
                                    <>
                                        <NotificationBadge
                                            notificationStatus={"custom"}
                                            badgeVariant={"default"}
                                            badgeAriaLabel={"Badge aria label"}
                                            isSmall={false}
                                            backgroundColor={'#4956B0'}
                                        />
                                    </>
                                }
                            </>
                        }   
                   

                    {/*booking.codeIup*/booking.reservationCode}
                </span>
            </td>
            <td  className="ff-lato">{parseDateForDS(moment.unix(booking.date).format(DATE_FORMAT),IParseDateFormatType.DATE_FORMAT1)}</td>
            <td  className="ff-lato">{booking.time}</td>
            <td  className="ff-lato">{booking.businessName}</td>
            <td  className="ff-lato">{booking.shipperName}</td>
            <td  className="ff-lato">{parseService(booking.service)}</td>
            {type===EntityType.BOOKING && <td><TableRighArrow onClick={() => {
                const edit:boolean = (booking.status===CalendarSlotStatus.PENDING && booking.prereservation)
                navigate(RoutePath.B2B_BOOKINGS_INFO + `/${booking.codeIup}`,{state:{edit:edit}});
            
            }} /></td>}
        </tr>
    });
    return tableRows;
}

/*export const getBookingLegend = (t:TFunction<[string, string, string], undefined>) => {

    return <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "16px"}}>
        {[
            CalendarSlotStatus.CONFIRMED,
            CalendarSlotStatus.PENDING,
            CalendarSlotStatus.REJECTED,
            CalendarSlotStatus.CLOSED,
        ].map((status: CalendarSlotStatus, index: number) => {
            return (
                <div key={uuid()} style={{display:"flex", alignItems:"center", gap:"4px"}}>
                    <DsBadge notificationStatus={getBookingBadgeStatus(status)} isSmall={true} backgroundColor={getBookingBadgeStatus(status)==="custom"?"#320216":undefined}/>
                    <span className="legendaLabel--contract">
                        {t('booking.bookingList.tableLegend.' + index,{ns:'b2b'})}
                    </span>
                </div>
            )
        })
        }
        <div key={uuid()} style={{display:"flex", alignItems:"center", gap:"4px"}}>
            <NotificationBadge
                notificationStatus={"custom"}
                badgeVariant={"default"}
                badgeAriaLabel={"Badge aria label"}
                isSmall={true}
                backgroundColor={'#9A0557'}
                badgeText={t('booking.bookingList.tableLegend.4',{ns:'b2b'})}
            />
            <span className="legendaLabel--contract">
                {t('booking.bookingList.tableLegend.4',{ns:'b2b'})}
            </span>
        </div>
        <div key={uuid()} style={{display:"flex", alignItems:"center", gap:"4px"}}>
            <NotificationBadge
                notificationStatus={"custom"}
                badgeVariant={"default"}
                badgeAriaLabel={"Badge aria label"}
                isSmall={true}
                backgroundColor={'#4956B0'}
                badgeText={t('booking.bookingList.tableLegend.5',{ns:'b2b'})}
            />
            <span className="legendaLabel--contract">
                {t('booking.bookingList.tableLegend.5',{ns:'b2b'})}
            </span>
        </div>
    </div>
}*/

export const getBookingLegend = (
    t: TFunction<[string, string, string], undefined>,
    statusesToShow: CalendarSlotStatus[]
): JSX.Element => {

    // Colori personalizzati per determinati status
    const statusColors: Partial<Record<CalendarSlotStatus, string>> = {
        [CalendarSlotStatus.CLOSED]: "#320216",
        [CalendarSlotStatus.CANCELLED]: "#9A0557",
        [CalendarSlotStatus.SLOT_DELETED]: "#4956B0",
        [CalendarSlotStatus.VACANT]: "#267f8f",
    };

    // Mappa lo status alla chiave dell'etichetta nella i18n
    const getLegendKeyFromStatus = (status: CalendarSlotStatus): number => {
        switch (status) {
            case CalendarSlotStatus.CONFIRMED: return 0;
            case CalendarSlotStatus.PENDING: return 1;
            case CalendarSlotStatus.REJECTED: return 2;
            case CalendarSlotStatus.CLOSED: return 3;
            case CalendarSlotStatus.CANCELLED: return 4;
            case CalendarSlotStatus.SLOT_DELETED: return 5;
            case CalendarSlotStatus.VACANT: return 6;
            default: return -1; // fallback
        }
    };

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "16px" }}>
            {statusesToShow.map((status: CalendarSlotStatus) => {
                const badgeStatus = getBookingBadgeStatus(status); // funzione già esistente
                const customColor = badgeStatus === "custom" ? statusColors[status] : undefined;
                const legendKey = getLegendKeyFromStatus(status);

                return (
                    <div key={uuid()} style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        {(status === CalendarSlotStatus.CANCELLED || status === CalendarSlotStatus.SLOT_DELETED) ? (
                            <NotificationBadge
                                notificationStatus={"custom"}
                                badgeVariant={"default"}
                                badgeAriaLabel={"Badge aria label"}
                                isSmall={true}
                                backgroundColor={customColor}
                                badgeText={t(`booking.bookingList.tableLegend.${legendKey}`, { ns: 'b2b' })}
                            />
                        ) : (
                            <DsBadge
                                notificationStatus={badgeStatus}
                                isSmall={true}
                                backgroundColor={customColor}
                            />
                        )}
                        <span className="legendaLabel--contract">
                            {t(`booking.bookingList.tableLegend.${legendKey}`, { ns: 'b2b' })}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};
export const getBadgeDelegations = (status: BadgeStatus, isSmall?: boolean) => {
    let notificationStatus = ''
    if (status === BadgeStatus.APPROVED) {
        notificationStatus = 'confirm'
    } else if (status === BadgeStatus.TOAPPROVE) {
        notificationStatus = 'warning'
    } else if (status === BadgeStatus.NOTAPPROVED){
        notificationStatus = 'error'
    }
    return (
        <ds-notification-badge
            notification-status={notificationStatus}
            badge-variant="default"
            badge-number="0"
            badge-aria-label="Badge aria label"
            is-small={isSmall ? "true" : "false"}
            background-color=""
        ></ds-notification-badge>
    )

}
export const getDelegationLegend = (delegation?:boolean) => {
    if(delegation===true){
        return <div style={{ marginTop: '20px', height: '5%' }}>
            <DriverVehicleListTableLegend entityType={EntityType.VEHICLE} tableType={BadgeStatus.NOT_CREDITED} delegation={true}/>
        </div>  
    }else{
        return <div style={{ marginTop: '20px', height: '5%' }}>
        <DriverVehicleListTableLegend entityType={EntityType.VEHICLE} tableType={BadgeStatus.NOT_CREDITED} />
    </div>  
    }
    
}
const getBadgeStatus2 = (status: BadgeStatus) => {
        let notificationStatus = "";

        if (status === BadgeStatus.EXPIRED) {
            notificationStatus = 'error'
        } else if (status === BadgeStatus.TO_CREDIT) {
            notificationStatus = 'warning'
        } else if (status === BadgeStatus.VALID) {
            notificationStatus = 'confirm'
        }

        return notificationStatus;
    }
export const documentTableLegend = (text1:string, text2:string, text3?:string) => {
    return <>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "24px" }}>
            <DsBadge notificationStatus={getBadgeStatus2(BadgeStatus.VALID)} isSmall={true} />
            <span className="legendaLabel--contract">
                {/*In corso*/}
                {text1}
            </span>
            <DsBadge notificationStatus={getBadgeStatus2(BadgeStatus.EXPIRED)} isSmall={true} />
            <span className="legendaLabel--contract">
                {/*Scaduto*/}
                {text2}
            </span>
            {text3 &&
                <>
                    <DsBadge notificationStatus={"warning"} isSmall={true} />
                    <span className="legendaLabel--contract">
                        {/*Not inserted*/}
                        {text3}
                    </span>
                </>
            }
        </div>

    </>
}

export const getTableRowsDelegations = (transportData:any) => {
    const tableRowsDelegations = transportData?.delegations.map((delegation: IDelegation) => {

        return (
            <tr key={delegation.delegationId}>
                <td>
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {delegation.document.status === BadgeStatus.EXPIRED ? getBadgeDelegations(BadgeStatus.EXPIRED, true) : (delegation.document.status === BadgeStatus.TOAPPROVE ? getBadgeDelegations(BadgeStatus.TOAPPROVE, true) : (delegation.document.status === BadgeStatus.APPROVED ? getBadgeDelegations(BadgeStatus.APPROVED, true) : getBadgeDelegations(BadgeStatus.NOTAPPROVED, true))) }
                        {delegation.businessName}
                    </span>
                </td>
                <td>
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        {delegation.document.expire !== null && moment.unix(delegation.document.expire).format(DATE_FORMAT)}
                    </span>
                </td>
            </tr>
        )
    });
    return tableRowsDelegations;
}